var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCheckCircleGreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 99.262,
    height: 99.262,
    viewBox: "0 0 99.262 99.262",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-check-circle",
    "data-name": "Icon awesome-check-circle",
    d: "M99.825,50.194A49.631,49.631,0,1,1,50.194.563,49.631,49.631,0,0,1,99.825,50.194ZM44.453,76.473,81.276,39.65a3.2,3.2,0,0,0,0-4.528l-4.528-4.528a3.2,3.2,0,0,0-4.528,0L42.189,60.624,28.168,46.6a3.2,3.2,0,0,0-4.528,0l-4.528,4.528a3.2,3.2,0,0,0,0,4.528L39.924,76.473a3.2,3.2,0,0,0,4.528,0Z",
    transform: "translate(-0.563 -0.563)",
    fill: "#16c27d"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckCircleGreen);
export default __webpack_public_path__ + "static/media/Icon-check-circle-green.7ac4f9819e3b306a5a1d8e4d3bbd44db.svg";
export { ForwardRef as ReactComponent };